const NullableCell = ({ cell: { value } }) => {
    if (value) {
        return String(value);
    }
    return null;
};

export default NullableCell;
